import { Injector } from "@angular/core";
import { Art57Node } from "../Art57Node";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { SubstanceInternationalCode } from "../../../Data/Art57Data/SubstanceInternationalCode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstanceInternationalCode extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new SubstanceInternationalCode(new FieldDefinition(injector)),
        'Substance International Code'
      );
  
      this.parent = parent;
      this.labelNodeName = 'Substance Internatinal Code';
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(): void {
      if (
        this.data &&
        this.data.model &&
        this.data.model.referencetext &&
        this.data.model.referencetext.value
      ) {
        this.label = this.data.model.referencetext.value;
      } else {
        this.label = this.labelTemplate;
      }
    }
  
    override getMessage(): any {
      if (this.data.model && Object.keys(this.data.model).length > 0) {
        return this.data.model;
      } else {
        return;
      }
    }

    override getListItem(): any[] {
      return [
        this.data.model &&
          this.data.model.sourcecode &&
          this.data.model.sourcecode.name
          ? this.data.model.sourcecode.name
          : 'Not selected',
        this.data.model &&
          this.data.model.referencetext &&
          this.data.model.referencetext.value
          ? this.data.model.referencetext.value
          : 'Not selected',
      ];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node {
      let clonedNode: TreeNodeSubstanceInternationalCode =
        new TreeNodeSubstanceInternationalCode(this.ioc!, newParent);
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.refreshLabel();
  
      return clonedNode;
    }

    override validateBusinessRules(): any[] {
      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];

      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
  }
  }